import styled from "styled-components"

export const HeaderContainer = styled.div`
  /* height: calc(${({ theme }) => theme.baseline} * 2); */
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  flex-direction: column;
  margin: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding-top: 20px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
    flex-direction: row;
    justify-content: space-between;
    width: 1024px;
    margin: 0 auto;
    padding-top: 20px;
    align-items: center;
  }
`

export const LogoContainer = styled.div`
  a {
    text-decoration: none;
    color: #fff;
    h1 {
      font-family: "Dancing Script", cursive;
      font-size: ${({ theme }) => theme.fontSizes.xl};
      padding: 0;
      margin-bottom: 15px;
      line-height: 0;
    }
    p {
      font-size: ${({ theme }) => theme.fontSizes.xs};
      margin: 0;
    }
  }
`

export const NavigationContainer = styled.nav`
  display: inline-flex;
  align-items: center;
  li {
    list-style: none;
    & :not(:last-child) {
      margin-right: 20px;
    }
  }

  li a {
    text-decoration: none;
    color: #fff;
    font-size: ${({ theme }) => theme.fontSizes.sm};
    text-transform: uppercase;
    &:hover {
      border-bottom: 2px solid #fff;
      transition: ease 0.1s;
    }
  }
`
